var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.851 16.988-2.404 5.584-.544 1.26h.002a7.81 7.81 0 0 0 2.998.003 7.125 7.125 0 0 0 2.381-1.076l-2.433-5.77z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.827 19.44z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.657 10.326.013 5.06v.002l2.52.779 2.66.82-5.193-6.66z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.67 15.389 2.52.779-2.52-.78zM14.655 10.327h.003-.003z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.414 4.09A6.572 6.572 0 0 0 9.27 6.582l-.033.046-.059.08 5.48 3.617-1.244-6.235z",
    fill: "#29A5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.035 18.327 5.386-1.338-4.564-2.526c-.849 1.535-.923 2.928-.822 3.864z",
    fill: "#73B158"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.995 12.658.003.003-.003-.003z",
    fill: "#7CBC56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.037 18.36.006.053.012.064c.344 2.009 1.416 3.237 2.157 3.868l3.21-5.353-5.387 1.337.002.03z",
    fill: "#68A855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.434 22.526c.013.01.027.02.038.03l.03.022c1.085.803 2.128 1.319 3.967 1.415a6.715 6.715 0 0 0 .881-.016c-.492-1.795-1.85-6.73-1.93-6.983v-.002l-3.21 5.353c.08.067.154.128.224.181z",
    fill: "#5B9E54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.35 23.977.003.001.078-.007.05-.005.068-.007c1.138-.132 2.065-.526 2.682-.789.148-.063.278-.118.386-.16a12.521 12.521 0 0 1-3.03-2.596v-.001a14.947 14.947 0 0 1-.76-.97 12.958 12.958 0 0 1-.41-.605 14.572 14.572 0 0 1-.41-.675 7.55 7.55 0 0 1-.298-.553c-.288-.615-.284-.608-.288-.618",
    fill: "#5A9252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.335 5.222a6.556 6.556 0 0 0-1.981-.961 4.85 4.85 0 0 0-1.607-.256l-.032-.001a6.49 6.49 0 0 0-1.24.077l-.06.01 1.24 6.235 3.768-5.039c-.029-.021-.057-.044-.087-.065z",
    fill: "#1E98B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.858 8.832a6.535 6.535 0 0 0-2.436-3.545l-3.767 5.04h.002l6.207-1.472-.006-.023z",
    fill: "#218DA5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.115 11.225-.002.083.002-.083zM14.67 15.389a.439.439 0 0 0-.025.009l.026-.008v-.001z",
    fill: "#7CBC56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.67 15.389a.23.23 0 0 0-.025.008c-.003 0-.005 0 0 0-.264.077-.322.096-5.224 1.592h10.43l-2.66-.821-2.52-.78z",
    fill: "#95C65B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.646 15.397c.002-.002.011-.004.025-.008l-.025.008z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.952 11.547-.015.007c-1.302.656-2.354 1.614-2.965 2.707l-.008.015a8.787 8.787 0 0 0-.107.186l4.564 2.525-1.47-5.44z",
    fill: "#83BD5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.658 10.326 9.178 6.71a6.49 6.49 0 0 0-1.244 3.562c0 .006-.034.49.017 1.27 0 .002 0 .004.002.007.134-.067.27-.131.402-.188v-.003.003a12.68 12.68 0 0 1 3.061-.875c.37-.056.742-.098 1.114-.128.727-.057 1.465-.044 2.128-.03z",
    fill: "#25B3C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.67 15.386-.013-5.06-5.236 6.662c4.902-1.497 4.96-1.517 5.224-1.593-.015.004.022-.008.025-.009z",
    fill: "#9EC95B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.67 15.387-.013-5.06.013 5.06z",
    fill: "#7CBC56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.421 16.989 5.234-6.662c-.66-.015-1.399-.027-2.126.03a15.743 15.743 0 0 0-1.43.18c-.871.158-1.786.414-2.745.823v-.003.003c-.133.056-.267.12-.402.187H7.95l.002.001 1.47 5.44z",
    fill: "#91C45A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.416 18.836zM10.006 18.158zM10.156 18.416zM9.709 17.607zM9.709 17.61c-.191-.376-.283-.607-.288-.616.005.01.097.24.288.616z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.852 16.988c-.639.254-1.283.515-1.925.777a382.188 382.188 0 0 0-4.813 2.002l-.949.4-.005.002-.572.241a12.537 12.537 0 0 0 3.03 2.598c.508.296 1.17.54 2.13.789l.06.015.006.001.09.018c.013.003-.014-.002 0 0l.544-1.26 2.404-5.583z",
    fill: "#83BD5C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.03 18.961z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.421 16.99v.002c.005.01.097.24.288.615a11.402 11.402 0 0 0 .448.81 14.856 14.856 0 0 0 1.43 1.993l.573-.241c.002 0 .003 0 .005-.002l.948-.4 1.917-.805c.963-.402 1.931-.803 2.897-1.197.641-.262 1.286-.523 1.924-.777l-10.43.001z",
    fill: "#91C45A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.062 9.976a6.551 6.551 0 0 0-.184-1.071l-.014-.051-6.207 1.47v.002l6.337 2.33.002.002c.013-.13.026-.25.041-.371.034-.264.064-.682.075-.982l.002-.083a9.617 9.617 0 0 0-.052-1.246z",
    fill: "#20839F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.985 17.08a7.189 7.189 0 0 0-.363-1.773l-4.77 1.68 4.936 2.091c.124-.5.259-1.209.197-1.998z",
    fill: "#5B9E54"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.788 19.08-4.936-2.092 2.43 5.77c1.731-1.226 2.278-2.879 2.285-2.897.067-.215.12-.4.167-.575h.001l.017-.067.011-.04.002-.008.023-.092z",
    fill: "#68A855"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.657 10.326 5.194 6.661c.006-.014.635-1.107 1.143-4.33l-6.337-2.33z",
    fill: "#267491"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.59 15.21a6.898 6.898 0 0 0-2.54-3.24 6.188 6.188 0 0 0-.942-.532l.005-.131c-.011.3-.041.717-.075.981a13.8 13.8 0 0 0-.043.37c-.508 3.222-1.137 4.317-1.143 4.33l4.77-1.68c-.011-.033-.021-.066-.033-.098z",
    fill: "#5A9252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutApp);
export default __webpack_public_path__ + "static/media/aboutApp.f39601a7e874f049a09c3a454f7ad5fa.svg";
export { ForwardRef as ReactComponent };